// Web client apiKey (Firebase Console → Project settings → General → Web app).
// Set FIREBASE_WEB_API_KEY / FIREBASE_WEB_API_KEY_PROD in backend/.env.local; config-overrides.js
// mirrors them to REACT_APP_* so CRA injects them (see react-scripts/config/env.js).

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const sandboxFirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_WEB_API_KEY || "",
  authDomain: "clumse-sandbox.firebaseapp.com",
  projectId: "clumse-sandbox",
  storageBucket: "clumse-sandbox.firebasestorage.app",
  messagingSenderId: "990164295943",
  appId: "1:990164295943:web:your-app-id-here",
  measurementId: "G-YOUR-MEASUREMENT-ID",
};

export const prodFirebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_WEB_API_KEY_PROD ||
    process.env.REACT_APP_FIREBASE_WEB_API_KEY ||
    "",
  authDomain: "clumse-3a013.firebaseapp.com",
  projectId: "clumse-3a013",
  storageBucket: "clumse-3a013.firebasestorage.app",
  messagingSenderId: "435392523961",
  appId: "1:435392523961:web:your-app-id-here",
  measurementId: "G-YOUR-MEASUREMENT-ID",
  // Performance optimizations for production
  authEmulatorHost: null, // Ensure no emulator in production
  databaseURL: null, // Not using Realtime Database
  // Additional performance settings
  experimentalForceLongPolling: false, // Use WebSocket when possible
  experimentalAutoDetectLongPolling: false, // Disable auto-detection
};
